import React from 'react';
import banner from '../../../assets/images/IMG_6203.JPG';
import bannertest from '../../../assets/images/bannertest.jpg';

function Banner() {
  return (
    <div className="pb-16">
      <section>
        <figure
          className="hero__media js-hero__media aos-init aos-animate"
          data-aos="fade"
        >
          <picture>
            <source
              media="(max-width: 500px)"
              srcset={require('../../../assets/images/banner-sm.jpg')}
            />
            <source
              media="(max-width: 700px)"
              srcset={require('../../../assets/images/banner-sm.jpg')}
            />

            <img
              alt="1004"
              style={{ width: '100vw', maxWidth: '100%' }}
              src={bannertest}
            />
          </picture>
        </figure>
        <div className="relative h-[60vh] md:h-screen flex justify-end md:justify-center flex-col text-left md:text-right px-14 max-w-full pt-0 md:pt-0 items-end text-white">
          <div className="w-full lg:w-1/2">
            <h1 className="text-sm lg:text-3xl m-0 text-white font-medium md:font-thin">
              Fabrilum
            </h1>
            <h2 className="text-3xl lg:text-7xl md:text-white m-0 font-light">
              Somos Fabricantes
            </h2>
            <p className="text-sm lg:text-xl font-light">
              Con mas de 10 años
              <br />
              de experiencia en iluminación
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
export default Banner;
